import SPage from '@/utils/classes/SPage';

export const NAV_LIST_DEFAULT = [
  { id: 1, pageId: SPage.DASHBOARD.id, locked: false },
  { id: 2, pageId: SPage.INDICATORS.id, locked: true },
  { id: 3, pageId: SPage.ACTION_PLANS.id, locked: true },
  { id: 4, pageId: SPage.PENDING.id, locked: true },
  { id: 5, pageId: SPage.PROBLEMS.id, locked: true },
];
export const NAV_LIST_CONFIG_DEFAULT = [
  { id: 1, pageId: SPage.CFG_DETAILS.id },
  { id: 2, pageId: SPage.CFG_TEAMS.id },
  { id: 3, pageId: SPage.CFG_INDICATORS.id },
  { id: 4, pageId: SPage.CFG_ACTIONS.id },
  { id: 5, pageId: SPage.CFG_CFG_PAGES.id },
  { id: 6, pageId: SPage.CFG_MEETINGS.id },
  { id: 7, pageId: SPage.CFG_PROBLEMS.id },
  { id: 8, pageId: SPage.CFG_LOCATIONS.id },
  { id: 9, pageId: SPage.CFG_LEAVE.id },
];

export const actionCreationQueryParam = 'actionEditionModalId';
export const infoCreationQueryParam = 'infoEditionModalId';
export const pbReportingQueryParam = 'pbReportingModalId';
export const pbSheetQueryParam = 'pbSheetModalId';
export const ongoingGwQueryParam = 'ongoingGwModalId';
export const ishikawaModalQueryParam = 'ishikawaModalId';
export const fwModalQueryParam = 'fiveWhysModalId';
export const gwCreationQueryParam = 'gwCreationModalId';
export const modalEditionQueryParams = [
  actionCreationQueryParam,
  infoCreationQueryParam,
  pbReportingQueryParam,
  pbSheetQueryParam,
  ongoingGwQueryParam,
  ishikawaModalQueryParam,
  fwModalQueryParam,
  gwCreationQueryParam,
];
export const confirmLeavingQueryParams = [
  actionCreationQueryParam,
  infoCreationQueryParam,
  pbReportingQueryParam,
];


export default {
  NAV_LIST_DEFAULT,
  NAV_LIST_CONFIG_DEFAULT,
  modalEditionQueryParams,
  confirmLeavingQueryParams,
  actionCreationQueryParam,
  ongoingGwQueryParam,
  infoCreationQueryParam,
  pbReportingQueryParam,
  pbSheetQueryParam,
  ishikawaModalQueryParam,
  fwModalQueryParam,
};
